<template>
  <div id="app" @touchmove.stop="commentTouchmove">
    <router-view v-wechat-title="$route.meta.title" />
    <div class="appbox">
      <!-- 消息提示 -->
      <div class="toast" v-if="toast">
        <div class="content text-center" :class="$store.state.toastContent&&$store.state.toastContent.length>60?'wth':''">{{ $store.state.toastContent }}</div>
      </div>
      <!-- 登陆即注册 start 20211217 -->
      <!-- <div class="sign-up text-center" v-if="loginState">
        <div class="content">
          <div class="title bold">Sign up</div>
          <div class="text">Sign up for your own account</div>
          <div class="form">
            <div class="form-item">
              <input
                type="text"
                class="form-control"
                :class="registerTips[0] ? 'err' : ''"
                v-model="registerData.username"
                maxlength="14"
                placeholder="Username"
                @input="checkForm(0)"
              />
              <p class="error-tips text-left">{{ registerTips[0] }}</p>
            </div>
            <div class="form-item">
              <input
                type="password"
                class="form-control"
                :class="registerTips[1] ? 'err' : ''"
                v-model="registerData.password"
                maxlength="16"
                placeholder="Password"
                @input="checkForm(1)"
              />
              <p class="error-tips text-left">{{ registerTips[1] }}</p>
            </div>
            <div class="form-item">
              <input
                type="password"
                v-model="registerData.repassword"
                class="form-control confirm-pass"
                :class="registerTips[2] ? 'err' : ''"
                maxlength="16"
                placeholder="Confirm Password"
                @input="checkForm(2)"
              />
              <p class="error-tips text-left">{{ registerTips[2] }}</p>
            </div>
          </div>
          <div class="login-in-btn" @click="handleRegister">Log in</div>
          <div class="iconfont close" @click="loginFun(false)">&#xe6e2;</div>
        </div>
      </div> -->
      <!-- 登陆即注册 end -->
      <!-- 登录 -->
      <div class="login-warp text-center" v-if="loginState">
        <div class="content">
          <div class="title bold">Login</div>
          <!-- <div class="text">with your social network</div> -->
          <div class="text">With Google account</div>
          <div class="login-method text-center" v-if="isCn != 1">
            <a :href="AUTH_URL + '/oauth/auth/google?url=' + url" class="login-item-single">
              <img src="@/assets/img/login-google.jpg" />
            </a>
            <!-- <a :href="AUTH_URL + '/oauth/auth/google?url=' + url" class="login-item">
              <img src="@/assets/img/login-google.jpeg" /> -->
            <!-- <img src="@/assets/img/login-google.jpeg" class="visible-mobile" /> -->
            <!-- </a> -->
            <!-- <a :href="AUTH_URL + '/oauth/auth/facebook?url=' + url" class="login-item">
              <img src="@/assets/img/login-facebook.jpeg" /> -->
            <!-- <img src="@/assets/img/login-facebook.jpeg" class="visible-mobile" /> -->
            <!-- </a> -->
          </div>
          <div class="login-method text-center" style="justify-content: center" v-else>
            <!-- <a
              :href="AUTH_URL + '/oauth/auth/google?url=' + url"
              class="login-item"
            >
              <img src="@/assets/img/login-google.jpeg" />
            </a>
            <a
              :href="AUTH_URL + '/oauth/auth/facebook?url=' + url"
              class="login-item"
            >
              <img src="@/assets/img/login-facebook.jpeg" />
            </a> -->
            <a :href="isWx ? wxLoginUrl : wxLoginUrlPC" class="login-item" style="flex-glow: 0">
              <img src="@/assets/img/login-weixin.jpeg" />
              <!-- <img src="@/assets/img/login-weixin.jpeg" class="visible-mobile" /> -->
            </a>
          </div>
          <!-- <div class="login-method text-center clr" style="justify-content:center">
            <a :href="AUTH_URL + '/oauth/auth/google?url=' + url" class="login-item">
              <img src="@/assets/img/login-google.jpeg" class="hidden-mobile" />
              <img src="@/assets/img/Google.svg" class="visible-mobile" />
            </a>
          </div> -->
          <div class="login-line"><span>or</span></div>
          <div class="form">
            <div class="form-item">
              <input type="text" class="form-control" v-model="loginData.username" placeholder="Username" />
            </div>
            <div class="form-item">
              <input type="password" class="form-control" v-model="loginData.password" placeholder="Password" />
            </div>
          </div>
          <div class="text-left">
            <span @click="showRegister" class="register-link">Not a member? Sign up</span>
          </div>
          <div class="login-in-btn" @click="accountLogin">Log in</div>
          <div class="iconfont close" @click="loginFun(false)">&#xe6e2;</div>
        </div>
      </div>
      <!-- 注册 -->
      <div class="sign-up text-center" v-if="showReg">
        <div class="content">
          <div class="title bold">Sign up</div>
          <div class="text">Sign up for your account and it will be your winning voucher</div>
          <div class="form">
            <div class="form-item">
              <input type="text" class="form-control" :class="registerTips[0] ? 'err' : ''"
                v-model="registerData.username" maxlength="14" placeholder="Username" @input="checkForm(0)" />
              <p class="error-tips text-left">{{ registerTips[0] }}</p>
            </div>
            <div class="form-item">
              <input type="password" class="form-control" :class="registerTips[1] ? 'err' : ''"
                v-model="registerData.password" maxlength="16" placeholder="Password" @input="checkForm(1)" />
              <p class="error-tips text-left">{{ registerTips[1] }}</p>
            </div>
            <div class="form-item">
              <input type="password" v-model="registerData.repassword" class="form-control confirm-pass"
                :class="registerTips[2] ? 'err' : ''" maxlength="16" placeholder="Confirm Password"
                @input="checkForm(2)" />
              <p class="error-tips text-left">{{ registerTips[2] }}</p>
            </div>
          </div>
          <div>
            <a :href="AUTH_URL + '/oauth/auth/google?url=' + url" class="sign-bottom-login">
              <span>Log in directly with</span> <img src="@/assets/img/login-google.jpg" />
            </a>
          </div>
          <div class="login-in-btn" @click="handleRegister">Log in</div>
          <div class="iconfont close" @click="showReg = false">&#xe6e2;</div>
        </div>
      </div>
      <!-- 弹窗提示 -->
    </div>
    <Message v-if="showMessage" />
    <Result v-if="showResult" />
  </div>
</template>
<script>
import { AUTH_URL } from "@/util/config.js";
import Message from "@/components/LuckDraw/Message";
import Result from "@/components/LuckDraw/Result";
import { getUserData, registerUser, userLogin } from "@/util/data.js";
import { getUrlParams, showToast, getObjectStorage } from "@/util/utils.js";
import { getCountry, getWxUser, getWxConfig } from "@/util/data.js";
export default {
  components: {
    Message,
    Result,
  },
  data() {
    return {
      showReg: false,
      AUTH_URL,
      loginData: {
        username: "",
        password: "",
      },
      formData: {
        nickname: "",
        areaCode: "",
        mobile: "",
        email: "",
        country: "",
        countryName: "",
      },
      registerData: {
        username: "",
        password: "",
        repassword: "",
      },
      registerTips: ["", "", ""],
      registerField: ["username", "password", "repassword"],
      regions: [],
      token: "",
      userInfo: {},
      registerNickname: "",
      url: "",
      isCn: false,
      isWx: false,
    };
  },
  computed: {
    wxLoginUrl() {
      return AUTH_URL + "/weixin/auth?url=" + this.url;
    },
    wxLoginUrlPC() {
      return AUTH_URL + "/oauth/auth/weixin?url=" + this.url;
    },
    initState() {
      return this.$store.state.initState;
    },
    toast() {
      return this.$store.state.toast;
    },
    showMessage() {
      return this.$store.state.showMessage;
    },
    showResult() {
      return this.$store.state.showResult;
    },
    // formState(){
    //   return this.$store.state.showForm;
    // },
    formState: {
      get() {
        return this.$store.state.showForm;
      },
      set(v) {
        this.$store.state.showForm = v;
      },
    },
    loginState() {
      return this.$store.state.login;
    },
  },
  watch: {
    initState(newVal) {
      if (!newVal) return;
      if (this.userInfo.username) this.handleUser();
    },
    toast(newVal) {
      if (newVal) this.handleToast(newVal);
    },
    formState(newVal) {
      if (!newVal && newVal !== 0) return;
      let userDetail = this.$store.state.userDetail;
      if (userDetail && newVal === 0) {
        this.initFormData(userDetail);
      }
    },
  },
  created() {
    this.init();
    this.isWx = this.judgeWx();
    this.getRegions();
    let token = decodeURI(getUrlParams("token"));
    if (token) this.socialLogin(token);
    let code = decodeURI(getUrlParams("code"));
    if (code && !token) this.wxLogin(code);
    if (window.localStorage.getItem("userDetail")) {
      var info = JSON.parse(window.localStorage.getItem("userDetail"));
      this.$store.commit("updateUserDetail", info);
      this.formData.nickname = info.nickname;
      this.formData.email = info.email;
      this.formData.country = info.country;
      if (info.mobile) {
        this.formData.areaCode = info.mobile.split("-")[0];
        this.formData.mobile = info.mobile.split("-")[1];
      }
      return;
    }
    const { id, type } = this.$route.params;
    this.isCn = type == 1 || id == 24 || isCn == "1";
    this.url = window.location.href.split("?")[0];
    if (this.isCn && this.url) this.url = this.parseUrl();
    // this.url = this.url.replace("sanyglobal.com", "sanygroup.com");
  },
  mounted() {
    let login = getUrlParams("login"),
      token = this.$store.state.token || window.localStorage.getItem("token");
    if (login == 1 && !token)
      this.$nextTick(() => {
        this.loginFun(true);
      });
  },
  methods: {
    parseUrl() {
      const path = this.$route.path;
      return path.lastIndexOf("/") === path.length - 1 ? "https://activity.sanygroup.com" + path : "https://activity.sanygroup.com" + path + "/";
    },
    judgeWx() {
      let ua = navigator.userAgent.toLowerCase(),
        result = false;
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        result = true;
      }
      return result;
    },
    commentTouchmove() {
      return;
    },
    getCountryName(id) {
      let len = this.regions.length;
      for (let i = 0; i < len; i++) {
        let item = this.regions[i];
        if (item.id == id) {
          return item.name_en;
          break;
        }
      }
      return "";
    },
    initFormData(userDetail) {
      let arr = userDetail.mobile ? userDetail.mobile.split("-") : [];
      let mobile = arr[1] ? arr[1] : arr[0];
      let areaCode = arr[1] ? arr[0] : "";
      let countryName = this.getCountryName(userDetail.country);
      let formData = {
        nickname: userDetail.nickname || "",
        areaCode: areaCode || "",
        mobile: mobile || "",
        email: userDetail.email || "",
        country: userDetail.country || "",
        countryName,
      };
      this.formData = formData;
    },
    getRegions() {
      getCountry().then((res) => {
        if (res.code == 200) {
          let formData = this.formData;
          this.regions = res.data;
          if (formData.country) {
            formData.countryName = this.getCountryName(formData.country);
          }
          this.formData = formData;
        }
      });
    },
    chooseCountry(e) {
      let formData = this.formData;
      formData.countryName = this.getCountryName(e.target.value);
      this.formData = formData;
    },
    showRegister() {
      this.showReg = true;
      this.loginFun(false);
    },
    handleRegister() {
      let registerTips = [],
        errNum = 0;
      for (let i = 0; i < this.registerField.length; i++) {
        registerTips[i] = this.getTips(i);
        if (registerTips[i]) errNum++;
      }
      this.registerTips = [...registerTips];
      if (errNum > 0) return;
      let token =
        this.$store.state.token || window.localStorage.getItem("token");
      registerUser({
        username: this.registerData.username,
        password: this.registerData.password,
      })
        .then((res) => {
          if (res.code == 200) {
            this.showReg = false;
            showToast(this, "Register success!");
            this.accountLogin(1);
          } else showToast(this, res.msg);
        })
        .catch((err) => {
          showToast(this, "Register fail!");
        });
    },
    checkForm(index) {
      let registerTips = [...this.registerTips];
      registerTips[index] = this.getTips(index);
      this.registerTips = registerTips;
    },
    getTips(index) {
      let field = this.registerField[index];
      if (!field) return "";
      let value = this.registerData[field];
      if (!value) return "Please fill in " + field;
      else if (field == "password" && (value.length < 6 || value.length > 16))
        return field + " must be 6-16 characters";
      else if (field == "username" && (value.length < 4 || value.length > 14))
        return field + " must be 4-14 characters";
      else if (field == "repassword" && value != this.registerData.password)
        return "Two input password must be consistent";
      else return "";
    },
    async wxLogin(code) {
      const data = await getWxUser(code);
      if (data.code == 1 && data.data) {
        this.userInfo = data.data;
        this.$store.commit("updateToken", data.data.token);
        this.$store.commit("updateUserDetail", data.data);
        this.$store.commit("updateLoginState", false);
      }
      // this.$store.commit("updateToken", token);
    },
    socialLogin(token) {
      this.getUserInfo(token);
      this.$store.commit("updateToken", token);
    },
    accountLogin(type) {
      let username = "",
        password = "";
      if (type == 1) {
        username = this.registerData.username;
        password = this.registerData.password;
      } else {
        username = this.loginData.username;
        password = this.loginData.password;
      }
      if (!username) {
        showToast(this, "Please fill in username!");
        return;
      }
      if (!password) {
        showToast(this, "Please fill in password!");
        return;
      }
      userLogin({ username, password })
        .then((res) => {
          if (res.code == 200) {
            const { token, user_id } = res.data;
            this.$store.commit("updateToken", token);
            if (user_id) {
              this.$store.commit("updateUserDetail", res.data);
            } else {
              this.getUserInfo(res.data.token);
            }
            if (type != 1) showToast(this, "Login success!");
            this.loginFun(false);
          } else {
            showToast(this, res.msg);
          }
        })
        .catch((err) => {
          showToast(this, "Login fail!");
        });
    },
    getUserInfo(token) {
      getUserData(token).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.$store.commit("updateUserDetail", res.data);
          if (this.initState == 1) this.handleUser();
        }
      });
    },
    loginFun(bool) {
      this.$store.commit("updateLoginState", bool);
    },
    init() {
      let userInfo = getObjectStorage("userInfo") || "";
      if (userInfo) this.$store.commit("updateUser", userInfo);
      let userDetail = getObjectStorage("userDetail");
      if (userDetail) this.$store.commit("updateUserDetail", userDetail);
      this.isMobile();
      this.listenResize();
    },
    listenResize() {
      window.addEventListener("resize", () => {
        this.isMobile();
      });
    },
    isMobile() {
      let winWidth =
        window.innerWidth ||
        document.body.clientWidth ||
        document.documentElement.clientWidth;
      if (winWidth <= 768) {
        this.$store.commit("updateMobile", true);
      } else {
        this.$store.commit("updateMobile", false);
      }
    },
    handleToast() {
      let time = this.$store.state.time || 1000;
      setTimeout(() => {
        this.$store.commit("updateToast", { status: false });
      }, time);
    },
  },
};
</script>
<style lang="scss">
#app {
  overflow: hidden;
}

.appbox {
  .toast {
    z-index: 99999 !important;
    color: white;
  }

  .toast,
  .login-warp,
  .register-data,
  .sign-up {
    z-index: 999;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;

    .content {
      position: absolute;
      top: 50%;
      left: 50%;
      min-width: 180px;
      transform: translate(-50%, -50%);
      background: rgba(0, 0, 0, 0.8);
      padding: 50px 30px;
      max-width: 200px;
      border-radius: 6px;

      .time {
        font-size: 24px;
        text-align: center;
        color: #ffc84d;
      }
    }

    .form {
      margin-top: 12px;
    }

    .form-control {
      width: 100%;
      height: 56px;
      line-height: 2;
      border: 1px solid #c3c3c3;
      outline: none;
      margin-top: 20px;
      font-size: 16px;
      padding: 0 6px;

      &.err {
        border: 1px solid #ef3c36;
      }
    }

    .register-link {
      cursor: pointer;
      color: #3e9af9;
      display: inline-block;
      margin-top: 14px;
    }

    .login-in-btn {
      line-height: 50px;
      width: 100%;
      background: #ef3c36;
      color: #fff;
      font-size: 24px;
      margin-top: 30px;
      cursor: pointer;
    }
  }
  .toast .content.wth{
    max-width: 420px;
  }
  .login-warp,
  .register-data,
  .sign-up {
    background: rgba(0, 0, 0, 0.5);

    .content {
      width: 800px;
      height: 600px;
      max-width: 800px;
      border-radius: 0;
      background: #fff;
      padding: 70px 110px 200px;
      color: #606060;
      font-size: 16px;
      line-height: 1.4;
      position: relative;

      .title {
        font-size: 36px;
        color: #1d1d1d;
      }

      .close {
        position: absolute;
        top: 20px;
        right: 30px;
        width: 40px;
        line-height: 40px;
        font-size: 20px;
        cursor: pointer;
      }
    }
  }

  .sign-up {
    .content {
      .form {
        margin-top: 0;

        .form-item {
          position: relative;
        }

        .form-control {
          margin-top: 30px;
        }

        .error-tips {
          color: #ef3c36;
          font-size: 12px;
          position: absolute;
          top: 100%;
          left: 0;
          text-transform: capitalize;
        }
      }

      .login-in-btn {
        margin-top: 50px;
      }

      .sign-bottom-login {
        width: 100%;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        color: #222;
        position: relative;
        bottom: -36px;

        img {
          width: 100px;
          margin-left: 8px;
        }
      }
    }
  }

  .login-warp {
    .login-method {
      margin-top: 30px;
      font-size: 0;
      display: flex;
      justify-content: space-between;

      .login-item,
      .login-item-single {
        width: calc(50% - 10px);
        color: #606060;
        position: relative;
        margin-left: -1px;

        &:first-child {
          margin-left: 0;
        }

        img {
          display: block;
          max-width: 100%;
        }
      }

      .login-item-single {
        width: 100%;
        border: 1px solid #c3c3c3;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 100px;
        }
      }
    }

    .login-line {
      font-size: 16px;
      position: relative;
      margin-top: 16px;

      span {
        background: #fff;
        position: relative;
        z-index: 2;
        display: inline-block;
        padding: 0 10px;
        color: #c3c3c3;
      }

      &::after {
        z-index: 1;
        content: "";
        height: 2px;
        width: 100%;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translate(0, -50%);
        background: #c3c3c3;
      }
    }
  }

  .register-data {
    .content {
      padding: 65px 100px;
      height: auto;

      .form {
        color: #1d1d1d;
        margin-top: 50px;

        .form-item {
          margin-bottom: 20px;
        }

        label {
          width: 190px;
          line-height: 50px;
          font-size: 20px;
        }

        .form-control {
          margin-top: 0;

          &.area-code {
            width: 130px;
            margin-right: 10px;
          }

          &.code-body {
            width: calc(100% - 140px);
          }

          &.choosed {
            color: #1d1d1d;
          }
        }

        select.form-control {
          color: #777;
        }
      }

      .submit-btn {
        width: 100%;
        line-height: 60px;
        font-size: 24px;
        background: #e60012;
        color: #fff;
        margin: 0 auto;
        margin-top: 50px;
        cursor: pointer;
      }
    }
  }

  .bind-data.register-data .content {
    .icon {
      margin-bottom: 20px;
    }

    .text-2,
    .text {
      width: 100%;
      margin: 0 auto;
      color: #939393;
      margin-top: 10px;
    }

    .text-2 {
      font-size: 12px;
      width: 536px;
      margin-top: 40px;
    }

    .form {
      margin-top: 36px;

      label {
        width: 170px;
        line-height: 40px;
        margin-right: 20px;
      }

      .form-control {
        height: 56px;
      }

      .submit-btn {
        margin-top: 40px;
        line-height: 50px;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .appbox {
    .toast {
      .content {
        max-width: 240px;
        min-width: 80px;
        padding: 25px;
        font-size: 15px;
      }
    }

    .login-warp,
    .register-data,
    .sign-up {
      .content {
        font-size: 14px;
        min-width: 50px;
        width: calc(100% - 30px);
        max-width: 360px;
        padding: 40px 28px;

        .icon {
          width: 90px;
          margin: 0 auto;
          margin-bottom: 14px;

          img {
            width: 90px;
          }
        }

        .title {
          font-size: 20px;
        }

        .time {
          font-size: 17px;
        }

        .form {
          margin-top: 25px;

          label {
            display: none;
          }

          .form-item {
            margin-bottom: 10px;
          }

          .form-control {
            width: 285px;
            max-width: 100%;
            height: 40px;
            font-size: 15px;

            &.area-code {
              width: 100px;
              margin-right: 5px;
            }

            &.code-body {
              width: 179px;
            }
          }

          .submit-btn {
            width: 165px;
            margin-top: 34px;
            line-height: 40px;
            font-size: 16px;
          }
        }

        .close {
          color: #000;
          width: 20px;
          line-height: 20px;
          right: 10px;
          top: 10px;
          font-size: 16px;
        }

        .sign-bottom-login {
          padding: 10px 6px 0;
          bottom: -30px;
        }
      }
    }

    .bind-data.register-data {
      .content {
        padding: 28px;

        .text-2,
        .text {
          width: 315px;
          position: relative;
          margin-left: -15px;
          margin-top: 5px;
        }

        .text-2 {
          margin-top: 10px;
        }

        .form {
          margin-top: 20px;

          .submit-btn {
            margin-top: 20px;
            line-height: 40px;
          }

          .form-control {
            height: 40px;
            line-height: 30px;
          }
        }

        .icon {
          margin-bottom: 8px;
        }
      }
    }

    .login-warp {
      .content {
        padding: 43px 15px 35px;
        height: auto;

        .login-method {
          margin-top: 20px;
          display: flex;
          justify-content: space-around;

          .login-item {
            margin: 0 0 0 -1px;
          }

          .login-item img {
            width: 150px;
            margin-bottom: 0;
          }
        }

        .form {
          margin-top: 0;

          .form-item {
            margin-bottom: 0;
          }

          .form-control {
            margin-top: 15px;
            width: 100%;
          }
        }
      }

      .register-link {
        margin-top: 10px;
      }

      .login-in-btn {
        margin-top: 25px;
        line-height: 36px;
        font-size: 16px;
      }

      .login-line {
        margin-top: 10px;

        &::after {
          height: 1px;
        }
      }
    }

    .sign-up {
      .content {
        height: auto;

        .form {
          margin-top: 0;

          .form-item {
            margin-bottom: 0;
          }
        }

        .login-in-btn {
          margin-top: 40px;
          font-size: 16px;
          line-height: 36px;
        }
      }
    }
  }
}
@media screen and (max-width: 540px) {
  .appbox .toast .content.wth{
    width: 80vw;
    max-width: 540px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue